const FounderNote = () => (
  <section className="relative">
    <div className="max-w-3xl mx-auto px-4 pb-16 md:pb-24">
      <div className="glass-panel rounded-3xl p-6 md:p-8 flex flex-col sm:flex-row gap-5 items-start">
        <div className="w-14 h-14 shrink-0 rounded-full bg-crystal-orange/20 border border-crystal-orange/40 flex items-center justify-center text-crystal-orange font-semibold text-lg">
          CH
        </div>
        <div>
          <div className="text-white font-semibold mb-2">A note from the founder</div>
          <p className="text-white/80 leading-relaxed">
            I worked in the industry for years and always hated pen and paper. I built
            Crystal HACCP to have everything in one place. Based in Oslo — if you have a
            question, email me directly at{" "}
            <a
              href="mailto:info@crystalhaccp.com"
              className="text-accent-on-dark underline hover:text-white"
            >
              info@crystalhaccp.com
            </a>{" "}
            and you'll get me, not a ticket queue.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default FounderNote;